import {closeGlobalPlayer} from '../../GlobalPlayerManager';
import React, {useEffect, useState} from 'react';
import useVideoPlayerParamsNumeric from './hooks/useVideoPlayerParamsNumeric';
import LegacyVideoPlayer from './components/LegacyVideoPlayer';
import {
  extractVideoParamsFromUmbraco,
  ExtractedVideoParams,
} from '../AppVideoPlayer/utils/extractVideoParamsFromUmbraco';
import apiConfig from '@src/Configs/apiConfig';
import {useCurrentLanguage} from '@src/Store/Slices/LanguageSlice/Language.selector';
const umbProjectAlias = apiConfig.umbProjectAlias;

const VideoPlayerPage = () => {
  const currentLanguage = useCurrentLanguage();

  React.useEffect(() => {
    return () => {
      closeGlobalPlayer();
    };
  }, []);

  const [extractedParams, setExtractedParams] =
    useState<ExtractedVideoParams | null>(null);
  const [umbracoLoading, setUmbracoLoading] = useState(false);

  const {umbracoId, vimeoId, byteplusId, youtubeId, paramsReady} =
    useVideoPlayerParamsNumeric();

  // On fetch uniquement si on a umbracoId et pas les autres ids
  const shouldFetchUmbraco =
    !!umbracoId && !byteplusId && !youtubeId && !vimeoId;

  // Fetch directly from Umbraco REST API
  useEffect(() => {
    if (!shouldFetchUmbraco) return;

    const fetchFromUmbraco = async () => {
      setUmbracoLoading(true);
      try {
        const response = await fetch(
          `https://cdn.umbraco.io/content/${umbracoId}?culture=${currentLanguage}`,
          {
            headers: {
              'Umb-Project-Alias': umbProjectAlias,
              'Accept-Language': currentLanguage,
            },
          },
        );
        const umbracoItem = await response.json();

        if (umbracoItem && umbracoItem.contentTypeAlias) {
          const extracted = extractVideoParamsFromUmbraco(
            umbracoItem,
            umbracoId!,
          );

          if (extracted) {
            setExtractedParams(extracted);

            // Sauvegarder dans localStorage pour que AppVideoPlayer les récupère
            const paramsToSave = {
              ...extracted,
              id: umbracoId,
              timestamp: Date.now(),
            };
            localStorage.setItem('v-params', JSON.stringify(paramsToSave));
          }
        }
      } catch (error) {
        console.error('Error fetching from Umbraco REST API:', error);
      } finally {
        setUmbracoLoading(false);
      }
    };

    fetchFromUmbraco();
  }, [umbracoId, shouldFetchUmbraco, currentLanguage]);

  if (!paramsReady) return null;

  if (umbracoLoading) {
    return (
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          <div>Loading video...</div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        <LegacyVideoPlayer extractedParams={extractedParams} />
      </div>
    </div>
  );
};

const styles: {
  pageContainer: React.CSSProperties;
  container: React.CSSProperties;
} = {
  pageContainer: {
    display: 'flex',
    zIndex: 49,
    marginTop: '100px',
    minHeight: '30vh',
  },
  container: {
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default VideoPlayerPage;
